import { Component, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-promotions',
  imports: [RouterOutlet, TranslatePipe],
  templateUrl: './promotions.component.html',
  styleUrl: './promotions.component.scss'
})
export class PromotionsComponent {
  readonly #router = inject(Router);

  readonly topTabs = [
    { id: 0, label: 'promotions.tabs.promotions', route: '/workspace/promotions' },
    { id: 1, label: 'promotions.tabs.missions', route: '/workspace/promotions/missions' }
  ];

  public get selectedTopTabId(): number {
    return this.#router.url.includes('/missions') ? 1 : 0;
  }

  public onTopTabClick(tabId: number): void {
    const route = this.topTabs.find(tab => tab.id === tabId)?.route ?? '';

    void this.#router.navigate([route]);
  }
}
